import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/nodata.png'


const _withScopeId = n => (_pushScopeId("data-v-a9e6f9a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "admin-list-pagination"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  style: {"width":"26px"}
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["colspan"]
const _hoisted_6 = {
  key: 0,
  class: "expansion-cell row-fixed",
  "aria-hidden": "true"
}
const _hoisted_7 = ["colspan"]
const _hoisted_8 = { style: {"line-height":"14px"} }
const _hoisted_9 = ["onMouseover", "onClick"]
const _hoisted_10 = ["data-action-key"]
const _hoisted_11 = {
  key: 0,
  class: "hightlight"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["title"]
const _hoisted_15 = ["colspan"]
const _hoisted_16 = ["onMouseleave"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  style: {"width":"26px"}
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  key: 0,
  class: "expansion-cell row-fixed",
  "aria-hidden": "true"
}
const _hoisted_23 = { style: {"height":"14px","line-height":"14px"} }
const _hoisted_24 = ["onMouseover", "onClick"]
const _hoisted_25 = {
  key: 0,
  class: "expansion-cell th-background",
  "aria-hidden": "true"
}
const _hoisted_26 = ["data-action-key"]
const _hoisted_27 = {
  key: 0,
  class: "hightlight"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["title"]
const _hoisted_31 = { key: 3 }
const _hoisted_32 = ["colspan"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, "沒有数据")
], -1))
const _hoisted_34 = [
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_ListText = _resolveComponent("ListText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.paginate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_pagination, {
            current: _ctx.listPaging.current.value,
            "page-size": _ctx.listPaging.pageSize.value,
            total: _ctx.listPaging.total.value,
            "show-size-changer": "",
            "show-quick-jumper": "",
            "show-less-items": "",
            onChange: _ctx.listPaging.change
          }, null, 8, ["current", "page-size", "total", "onChange"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _mergeProps(_ctx.$attrs, {
      ref: "container",
      "data-action-scope": "",
      onScroll: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollEvent($event))),
      class: ['table-container', {'responsive-table':_ctx.responsive,'compact-table':_ctx.compactEnabled}],
      style: [_ctx.baseStyle, {"border-right":"solid 1px #eaeaea"}]
    }), [
      _createElementVNode("table", {
        ref: "mainTable",
        class: _normalizeClass(['main-table',{'fixed-action-table':_ctx.fixedActions && _ctx.cols.some(_ctx.isActionColumn)}]),
        style: _normalizeStyle(_ctx.responsive?{width:_ctx.tableWidth,minWidth:_ctx.tableWidth}:{}),
        onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mouselevel && _ctx.mouselevel(...args)))
      }, [
        (_ctx.responsive || _ctx.fixedActions)
          ? (_openBlock(), _createElementBlock("colgroup", _hoisted_2, [
              (_ctx.showSubItems)
                ? (_openBlock(), _createElementBlock("col", _hoisted_3))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cols, (col, index) => {
                return (_openBlock(), _createElementBlock("col", {
                  key: index,
                  style: _normalizeStyle({width:col.width+'px'})
                }, null, 4))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.props.tableTitle)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
              _createElementVNode("th", {
                style: {"position":"sticky","top":"0"},
                colspan: _ctx.cols.length+(_ctx.showSubItems?1:0)
              }, _toDisplayString(_ctx.props.tableTitle), 9, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("tr", null, [
          (_ctx.responsive && _ctx.showSubItems)
            ? (_openBlock(), _createElementBlock("th", _hoisted_6))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cols, (col, cindex) => {
            return (_openBlock(), _createElementBlock("th", {
              colspan: !_ctx.responsive && cindex===0 && _ctx.showSubItems?2:1,
              class: _normalizeClass([..._ctx.getClassNames(col),'row-fixed', _ctx.tdCenter ? 'td-center' : '']),
              style: _normalizeStyle(_ctx.cacColumnStyle(col,true,false,cindex)),
              key: cindex
            }, [
              _renderSlot(_ctx.$slots, "headercell", { column: col }, () => [
                _createElementVNode("div", _hoisted_8, _toDisplayString(col.title), 1)
              ], true),
              (col.slots?.showSlot)
                ? _renderSlot(_ctx.$slots, "selectall", {
                    key: 0,
                    column: col
                  }, undefined, true)
                : _createCommentVNode("", true)
            ], 14, _hoisted_7))
          }), 128))
        ]),
        (_ctx.dataSource.length>0 )
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.dataSource, (row, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                row
                  ? (_openBlock(), _createElementBlock("tr", {
                      onMouseover: ($event: any) => (_ctx.handleMouseOver(index)),
                      onClick: _withModifiers(($event: any) => (_ctx.selectItem(row,index)), ["stop"]),
                      key: index
                    }, [
                      (_ctx.showSubItems)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            class: _normalizeClass([_ctx.responsive?'expansion-cell':'legacy-expansion-cell',_ctx.rowStatus.selectedIndex==index && _ctx.showSelected?'selected':'']),
                            style: {"font-size":"15px","text-align":"center","cursor":"pointer"}
                          }, [
                            (row.subRows && row.subRows.length>0)
                              ? (_openBlock(), _createBlock(_component_svg_icon, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.expandClick(row)),
                                  icon: row.expand?'expand':'collapse'
                                }, null, 8, ["onClick", "icon"]))
                              : _createCommentVNode("", true)
                          ], 2))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cols, (col, cindex) => {
                        return (_openBlock(), _createElementBlock("td", {
                          style: _normalizeStyle(_ctx.cacColumnStyle(col,false,false,cindex)),
                          class: _normalizeClass([..._ctx.getClassNames(col),'ellipsis',_ctx.rowStatus.overIndex==index ?'mover':'', _ctx.rowStatus.selectedIndex==index?'selected':'', _ctx.tdCenter ? 'td-center' : '']),
                          key: cindex
                        }, [
                          (!col.layoutPlaceholder)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (!col.slots && (col.dataIndex==='orderNumber' || _ctx.responsive && ['title','productName'].includes(col.dataIndex)))
                                  ? (_openBlock(), _createBlock(_component_ListText, {
                                      key: 0,
                                      value: row[col.dataIndex],
                                      kind: col.dataIndex==='orderNumber'?'order':'product'
                                    }, null, 8, ["value", "kind"]))
                                  : (_ctx.props.fixedActions && _ctx.isActionColumn(col))
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "admin-action-content",
                                        "data-action-key": _ctx.actionColumnKey(col)
                                      }, [
                                        _renderSlot(_ctx.$slots, "bodycell", {
                                          column: col,
                                          record: row,
                                          rowCount: _ctx.dataSource.length,
                                          rowIndex: index,
                                          slots: col.slots,
                                          extend: row.extendColumn
                                        }, undefined, true)
                                      ], 8, _hoisted_10))
                                    : (col.slots)
                                      ? _renderSlot(_ctx.$slots, "bodycell", {
                                          key: 2,
                                          column: col,
                                          record: row,
                                          rowCount: _ctx.dataSource.length,
                                          rowIndex: index,
                                          slots: col.slots,
                                          extend: row.extendColumn
                                        }, undefined, true)
                                      : (_ctx.props.searchColumn && _ctx.props.searchColumn.indexOf(col.dataIndex)>=0)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 3,
                                            style: _normalizeStyle(_ctx.cacColumnStyle(col,false,false,cindex))
                                          }, [
                                            (row.extendColumn)
                                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(row.extendColumn[col.dataIndex], (crow, cindex) => {
                                                  return (_openBlock(), _createElementBlock("span", { key: cindex }, [
                                                    (_ctx.props.searchText && crow===_ctx.props.searchText.value)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(crow), 1))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(crow), 1))
                                                  ]))
                                                }), 128))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(row[col.dataIndex]), 1))
                                          ], 4))
                                        : (col.dataIndex)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 4,
                                              title: String(row[col.dataIndex] ?? ''),
                                              style: _normalizeStyle(_ctx.cacColumnStyle(col,false,true,cindex)),
                                              class: "ellipsis"
                                            }, _toDisplayString(row[col.dataIndex]), 13, _hoisted_14))
                                          : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 6))
                      }), 128))
                    ], 40, _hoisted_9))
                  : _createCommentVNode("", true),
                (_ctx.showSubItems && row.subRows && row.subRows.length>0 && row.expand)
                  ? (_openBlock(), _createElementBlock("tr", {
                      key: 'subRows'+index
                    }, [
                      _createElementVNode("td", {
                        colspan: _ctx.cols.length+(_ctx.responsive && _ctx.showSubItems?1:0),
                        class: _normalizeClass(_ctx.responsive?'expanded-table-cell':''),
                        style: _normalizeStyle(_ctx.responsive?{}:{padding:'5px 0'})
                      }, [
                        (_ctx.subTable)
                          ? (_openBlock(), _createElementBlock("table", {
                              key: 0,
                              class: _normalizeClass(['main-table',{'sub-table':_ctx.responsive,'fixed-action-table':_ctx.fixedActions && _ctx.subcols.some(_ctx.isActionColumn)}]),
                              style: _normalizeStyle(_ctx.responsive?{width:_ctx.tableWidth,minWidth:_ctx.tableWidth}:{marginLeft:'10px',borderLeft:'solid 3px green',width:'100%'}),
                              onMouseleave: ($event: any) => (_ctx.submouselevel(row))
                            }, [
                              (_ctx.responsive)
                                ? (_openBlock(), _createElementBlock("colgroup", _hoisted_17, [
                                    (_ctx.showSubItems)
                                      ? (_openBlock(), _createElementBlock("col", _hoisted_18))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subcols, (col, index) => {
                                      return (_openBlock(), _createElementBlock("col", {
                                        key: index,
                                        style: _normalizeStyle({width:col.width+'px'})
                                      }, null, 4))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.subTable.tableTitle)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                                    _createElementVNode("th", {
                                      style: {"position":"sticky","top":"0"},
                                      colspan: _ctx.subcols.length+(_ctx.showSubItems?1:0)
                                    }, _toDisplayString(_ctx.subTable.tableTitle), 9, _hoisted_20)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.subTable.showHeader)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                                    (_ctx.responsive && _ctx.showSubItems)
                                      ? (_openBlock(), _createElementBlock("th", _hoisted_22))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subcols, (subcol, cindex) => {
                                      return (_openBlock(), _createElementBlock("th", {
                                        class: _normalizeClass([..._ctx.getClassNames(subcol),'row-fixed', _ctx.tdCenter ? 'td-center' : '']),
                                        style: _normalizeStyle(_ctx.subcacColumnStyle(subcol,true,false,cindex)),
                                        key: cindex
                                      }, [
                                        _createElementVNode("div", _hoisted_23, _toDisplayString(subcol.title), 1)
                                      ], 6))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (row.subRows.length>0 )
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(row.subRows, (subRow, subIndex) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                      subRow
                                        ? (_openBlock(), _createElementBlock("tr", {
                                            onMouseover: ($event: any) => (_ctx.subhandleMouseOver(row,subIndex)),
                                            onClick: ($event: any) => (_ctx.subselectItem(row,subRow,subIndex)),
                                            key: subIndex
                                          }, [
                                            (_ctx.responsive && _ctx.showSubItems)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_25))
                                              : _createCommentVNode("", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subcols, (subCol, cindex) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                class: _normalizeClass(["th-background", [..._ctx.getClassNames(subCol),'ellipsis',row.subrowStatus?.overIndex==subIndex ?'mover':'', row.subrowStatus?.selectedIndex==subIndex && _ctx.showSelected?'selected':'', _ctx.tdCenter ? 'td-center' : '']]),
                                                style: _normalizeStyle(_ctx.subcacColumnStyle(subCol,false,false,cindex)),
                                                key: cindex
                                              }, [
                                                (!subCol.layoutPlaceholder)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      (!subCol.slots && (subCol.dataIndex==='orderNumber' || _ctx.responsive && ['title','productName'].includes(subCol.dataIndex)))
                                                        ? (_openBlock(), _createBlock(_component_ListText, {
                                                            key: 0,
                                                            value: subRow[subCol.dataIndex],
                                                            kind: subCol.dataIndex==='orderNumber'?'order':'product'
                                                          }, null, 8, ["value", "kind"]))
                                                        : (_ctx.props.fixedActions && _ctx.isActionColumn(subCol))
                                                          ? (_openBlock(), _createElementBlock("div", {
                                                              key: 1,
                                                              class: "admin-action-content",
                                                              "data-action-key": _ctx.actionColumnKey(subCol)
                                                            }, [
                                                              _renderSlot(_ctx.$slots, "bodycell", {
                                                                column: subCol,
                                                                record: subRow,
                                                                parentRecord: row,
                                                                rowCount: row.subRows.length,
                                                                rowIndex: subIndex,
                                                                slots: subCol.slots,
                                                                extend: subRow.extendColumn
                                                              }, undefined, true)
                                                            ], 8, _hoisted_26))
                                                          : (subCol.slots)
                                                            ? _renderSlot(_ctx.$slots, "bodycell", {
                                                                key: 2,
                                                                column: subCol,
                                                                record: subRow,
                                                                parentRecord: row,
                                                                rowCount: row.subRows.length,
                                                                rowIndex: subIndex,
                                                                slots: subCol.slots,
                                                                extend: subRow.extendColumn
                                                              }, undefined, true)
                                                            : (_ctx.props.searchColumn && _ctx.props.searchColumn.indexOf(subCol.dataIndex)>=0)
                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                  key: 3,
                                                                  style: _normalizeStyle(_ctx.subcacColumnStyle(subCol,false,false,cindex))
                                                                }, [
                                                                  (subRow.extendColumn)
                                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(subRow.extendColumn[subCol.dataIndex], (subcrow, cindex) => {
                                                                        return (_openBlock(), _createElementBlock("span", { key: cindex }, [
                                                                          (_ctx.props.searchText && subcrow===_ctx.props.searchText.value)
                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(subcrow), 1))
                                                                            : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(subcrow), 1))
                                                                        ]))
                                                                      }), 128))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(subRow[subCol.dataIndex]), 1))
                                                                ], 4))
                                                              : (subCol.dataIndex)
                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                    key: 4,
                                                                    title: String(subRow[subCol.dataIndex] ?? ''),
                                                                    style: _normalizeStyle(_ctx.subcacColumnStyle(subCol,false,true,cindex)),
                                                                    class: "ellipsis"
                                                                  }, _toDisplayString(subRow[subCol.dataIndex]), 13, _hoisted_30))
                                                                : _createCommentVNode("", true)
                                                    ], 64))
                                                  : _createCommentVNode("", true)
                                              ], 6))
                                            }), 128))
                                          ], 40, _hoisted_24))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 256))
                                : _createCommentVNode("", true)
                            ], 46, _hoisted_16))
                          : _createCommentVNode("", true)
                      ], 14, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          : (_openBlock(), _createElementBlock("tr", _hoisted_31, [
              _createElementVNode("td", {
                colspan: _ctx.cols.length+(_ctx.showSubItems?1:0),
                class: "no-data"
              }, _hoisted_34, 8, _hoisted_32)
            ]))
      ], 38)
    ], 16)
  ], 64))
}